import { json, useNavigate } from "react-router-dom";
import Logo from "../../assats/logo.webp";
import Location from "../../assats/location.webp";
import instagram from "../../assats/Instagram.webp";
import facebook from "../../assats/Facebook.webp";
import linkedin from "../../assats/LinkedIn.webp";
import youtube from "../../assats/youtube.webp";
import Avatar from 'react-avatar';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import userIcon from "../../assats/usericon.png";



import React, { useEffect, useState } from "react";
const Header = () => {
    const navigate = useNavigate();
    const [user, setUser] = useState()
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [isLogin, setIsLogin] = useState(false);
    const [open, setOpen] = useState(false);
    console.log("isLogin", isLogin);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    const confirLogout = () => {
        setOpen(false);
        localStorage.setItem("isLogin", false);
        setIsLogin(false)
    }
    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };
    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    useEffect(() => {
        const userData = localStorage.getItem("UserData");
        setUser(JSON.parse(userData));
        const LoginMethod = localStorage.getItem("isLogin");
        setIsLogin(JSON.parse(LoginMethod));
    }, [])

    return (
        <>
            <div className="md:mx-auto px-5 w-full bg-[#fff] shadow-lg">
                <header className="py-3">
                    <nav className=" container md:mx-auto flex justify-between">
                        <div>
                            <img src={Logo} alt="" className="h-16 cursor-pointer" onClick={() => navigate("/")} />
                        </div>
                        <div className="lg:hidden">
                            <button onClick={toggleMenu} className="navbar-burger flex items-center text-blue-600 p-3">
                                <svg className="block h-4 w-4 fill-current" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                    <title>Mobile menu</title>
                                    <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"></path>
                                </svg>
                            </button>
                        </div>
                        <ul className={`hidden lg:flex lg:mx-auto lg:flex lg:items-center lg:w-auto lg:space-x-6`}>
                            <li><a className="text-[16px] text-gray-900 hover:text-gray-500" href="/">Home</a></li>

                            <li><a className="text-[16px] text-gray-900 hover:text-gray-500" href="/about-us">About Us</a></li>

                            <li><a className="text-[16px] text-gray-900 hover:text-gray-500" href="/projects">Projects</a></li>

                            <li><a className="text-[16px] text-gray-900 hover:text-gray-500" href="/contact">Contact</a></li>

                            <li><a className="text-[16px] text-gray-900 hover:text-gray-500" href="/faq">FAQ</a></li>
                        </ul>
                        <div className={`hidden lg:flex flex-col lg:flex lg:items-center lg:w-auto lg:space-x-6 cursor-pointer`}>
                            {isLogin ?
                                <Avatar src={userIcon} size="40" round={true} onClick={handleClickOpen} color="#A35733" className="mt-1" /> :
                                <button className="rounded-full inline-flex items-center bg-[#915213] hover:bg-[#b68b60] border-0 py-2 mt-1.5 px-6 text-white" onClick={() => navigate("/login")}>
                                    Log In
                                </button>
                            }

                        </div>
                    </nav>
                    {isMenuOpen && (
                        <div className="md:hidden mt-5 transition duration-300 ease-in-out translate-x-0">
                            <ul className="flex flex-col space-y-3">
                                <li>
                                    <a className="cursor-pointer" href="/">Home</a>
                                </li>
                                <li>
                                    <a className="cursor-pointer" href="about-us">About Us</a>
                                </li>
                                <li>
                                    <a className="cursor-pointer" href="/projects">Projects</a>
                                </li>
                                <li>
                                    <a className="cursor-pointer" href="/contact">Contact</a>
                                </li>
                                <li>
                                    <a className="cursor-pointer" href="/faq">FAQ</a>
                                </li>
                            </ul>
                            <button className="rounded-full inline-flex items-center mt-5 bg-[#915213] hover:bg-[#b68b60] border-0 py-2  px-6 text-white" onClick={() => navigate("/login")}>
                                Log In
                            </button>
                        </div>
                    )}
                </header>
                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {"Confirm Logout"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Are You Sure You Want to Logout ?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={confirLogout}>Yes</Button>
                        <Button onClick={handleClose}>
                            No
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        </>
    )

}
export default Header;


// import { useState } from 'react';

// function Header() {
//     const [isMenuOpen, setIsMenuOpen] = useState(false);

//     const toggleMenu = () => {
//         console.log("ClickToggle");
//         setIsMenuOpen(!isMenuOpen);
//     };

//     return (
//         <div className="bg-blue-500">
//             <nav className="relative px-4 py-4 flex justify-between items-center bg-white">
//                 <a className="text-3xl font-bold leading-none" href="#">
//                     <svg className="h-10" alt="logo" viewBox="0 0 10240 10240">
//                         <path d="M8284 9162 c-2 -207 -55 -427 -161 -667 -147 -333 -404 -644 -733 -886 -81 -59 -247 -169 -256 -169 -3 0 -18 -9 -34 -20 -26 -19 -344 -180 -354 -180 -3 0 -29 -11 -58 -24 -227 -101 -642 -225 -973 -290 -125 -25 -397 -70 -480 -80 -22 -3 -76 -9 -120 -15 -100 -13 -142 -17 -357 -36 -29 -2 -98 -7 -153 -10 -267 -15 -436 -28 -525 -40 -14 -2 -45 -7 -70 -10 -59 -8 -99 -14 -130 -20 -14 -3 -41 -7 -60 -11 -19 -3 -39 -7 -45 -8 -5 -2 -28 -6 -50 -10 -234 -45 -617 -165 -822 -257 -23 -10 -45 -19 -48 -19 -7 0 -284 -138 -340 -170 -631 -355 -1107 -842 -1402 -1432 -159 -320 -251 -633 -308 -1056 -26 -190 -27 -635 -1 -832 3 -19 7 -59 10 -89 4 -30 11 -84 17 -120 6 -36 12 -77 14 -91 7 -43 33 -174 39 -190 3 -8 7 -28 9 -45 6 -35 52 -221 72 -285 7 -25 23 -79 35 -120 29 -99 118 -283 189 -389 67 -103 203 -244 286 -298 75 -49 178 -103 196 -103 16 0 27 16 77 110 124 231 304 529 485 800 82 124 153 227 157 230 3 3 28 36 54 74 116 167 384 497 546 671 148 160 448 450 560 542 14 12 54 45 90 75 88 73 219 172 313 238 42 29 77 57 77 62 0 5 -13 34 -29 66 -69 137 -149 405 -181 602 -7 41 -14 82 -15 90 -1 8 -6 46 -10 83 -3 37 -8 77 -10 88 -2 11 -7 65 -11 122 -3 56 -8 104 -9 107 -2 3 0 12 5 19 6 10 10 8 15 -10 10 -34 167 -346 228 -454 118 -210 319 -515 340 -515 4 0 40 18 80 40 230 128 521 255 787 343 118 40 336 102 395 113 28 5 53 11 105 23 25 5 59 12 75 15 17 3 41 8 55 11 34 7 274 43 335 50 152 18 372 29 565 29 194 0 481 -11 489 -19 2 -3 -3 -6 -12 -6 -9 -1 -20 -2 -24 -3 -33 -8 -73 -16 -98 -21 -61 -10 -264 -56 -390 -90 -649 -170 -1243 -437 -1770 -794 -60 -41 -121 -82 -134 -93 l-24 -18 124 -59 c109 -52 282 -116 404 -149 92 -26 192 -51 220 -55 17 -3 64 -12 105 -21 71 -14 151 -28 230 -41 19 -3 46 -7 60 -10 14 -2 45 -7 70 -10 25 -4 56 -8 70 -10 14 -2 53 -7 88 -10 35 -4 71 -8 81 -10 10 -2 51 -6 92 -9 101 -9 141 -14 147 -21 3 -3 -15 -5 -39 -6 -24 0 -52 -2 -62 -4 -21 -4 -139 -12 -307 -22 -242 -14 -700 -7 -880 13 -41 4 -187 27 -250 39 -125 23 -274 68 -373 111 -43 19 -81 34 -86 34 -4 0 -16 -8 -27 -17 -10 -10 -37 -33 -59 -52 -166 -141 -422 -395 -592 -586 -228 -257 -536 -672 -688 -925 -21 -36 -43 -66 -47 -68 -4 -2 -8 -7 -8 -11 0 -5 -24 -48 -54 -97 -156 -261 -493 -915 -480 -935 2 -3 47 -21 101 -38 54 -18 107 -36 118 -41 58 -25 458 -138 640 -181 118 -27 126 -29 155 -35 14 -2 45 -9 70 -14 66 -15 137 -28 300 -55 37 -7 248 -33 305 -39 28 -3 84 -9 125 -13 163 -16 792 -8 913 12 12 2 58 9 102 15 248 35 423 76 665 157 58 19 134 46 170 60 86 33 344 156 348 166 2 4 8 7 13 7 14 0 205 116 303 184 180 126 287 216 466 396 282 281 511 593 775 1055 43 75 178 347 225 455 100 227 236 602 286 790 59 220 95 364 120 485 6 28 45 245 50 275 2 14 7 41 10 60 3 19 8 49 10 65 2 17 6 46 9 65 15 100 35 262 40 335 3 39 8 89 10 112 22 225 33 803 21 1043 -3 41 -7 129 -11 195 -3 66 -8 136 -10 155 -2 19 -6 76 -10 125 -3 50 -8 101 -10 115 -2 14 -6 57 -10 95 -7 72 -12 113 -20 175 -2 19 -7 55 -10 80 -6 46 -43 295 -51 340 -2 14 -9 54 -15 90 -5 36 -16 97 -24 135 -8 39 -17 84 -20 100 -12 68 -18 97 -50 248 -19 87 -47 204 -61 260 -14 56 -27 109 -29 117 -30 147 -232 810 -253 832 -4 4 -7 -23 -8 -60z"></path>
//                     </svg>
//                 </a>
//                 <div className="lg:hidden">
//                     <button onClick={toggleMenu} className="navbar-burger flex items-center text-blue-600 p-3">
//                         <svg className="block h-4 w-4 fill-current" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
//                             <title>Mobile menu</title>
//                             <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"></path>
//                         </svg>
//                     </button>
//                 </div>
//                 <ul className={`hidden lg:flex lg:mx-auto lg:flex lg:items-center lg:w-auto lg:space-x-6 ${isMenuOpen ? '' : 'hidden'}`}>
//                     <li><a className="text-[16px] text-gray-400 hover:text-gray-500" href="/">Home</a></li>

//                     <li><a className="text-sm text-blue-600 font-bold" href="#">About Us</a></li>

//                     <li><a className="text-sm text-gray-400 hover:text-gray-500" href="#">Services</a></li>

//                     <li><a className="text-sm text-gray-400 hover:text-gray-500" href="#">Pricing</a></li>

//                     <li><a className="text-sm text-gray-400 hover:text-gray-500" href="#">Contact</a></li>
//                 </ul>
//                 <a className="hidden lg:inline-block lg:ml-auto lg:mr-3 py-2 px-6 bg-gray-50 hover:bg-gray-100 text-sm text-gray-900 font-bold  rounded-xl transition duration-200" href="#">Sign In</a>
//                 <a className="hidden lg:inline-block py-2 px-6 bg-blue-500 hover:bg-blue-600 text-sm text-white font-bold rounded-xl transition duration-200" href="#">Sign up</a>
//             </nav>
//             <div className="navbar-menu relative z-50 hidden">
//                 <div className="navbar-backdrop fixed inset-0 bg-gray-800 opacity-25"></div>
//                 <nav className="fixed top-0 left-0 bottom-0 flex flex-col w-5/6 max-w-sm py-6 px-6 bg-white border-r overflow-y-auto">
//                     <div className="flex items-center mb-8">
//                         <a className="mr-auto text-3xl font-bold leading-none" href="#">
//                             <svg className="h-12" alt="logo" viewBox="0 0 10240 10240">
//                                 <path xmlns="http://www.w3.org/2000/svg" d="M8284 9162 c-2 -207 -55 -427 -161 -667 -147 -333 -404 -644 -733 -886 -81 -59 -247 -169 -256 -169 -3 0 -18 -9 -34 -20 -26 -19 -344 -180 -354 -180 -3 0 -29 -11 -58 -24 -227 -101 -642 -225 -973 -290 -125 -25 -397 -70 -480 -80 -22 -3 -76 -9 -120 -15 -100 -13 -142 -17 -357 -36 -29 -2 -98 -7 -153 -10 -267 -15 -436 -28 -525 -40 -14 -2 -45 -7 -70 -10 -59 -8 -99 -14 -130 -20 -14 -3 -41 -7 -60 -11 -19 -3 -39 -7 -45 -8 -5 -2 -28 -6 -50 -10 -234 -45 -617 -165 -822 -257 -23 -10 -45 -19 -48 -19 -7 0 -284 -138 -340 -170 -631 -355 -1107 -842 -1402 -1432 -159 -320 -251 -633 -308 -1056 -26 -190 -27 -635 -1 -832 3 -19 7 -59 10 -89 4 -30 11 -84 17 -120 6 -36 12 -77 14 -91 7 -43 33 -174 39 -190 3 -8 7 -28 9 -45 6 -35 52 -221 72 -285 7 -25 23 -79 35 -120 29 -99 118 -283 189 -389 67 -103 203 -244 286 -298 75 -49 178 -103 196 -103 16 0 27 16 77 110 124 231 304 529 485 800 82 124 153 227 157 230 3 3 28 36 54 74 116 167 384 497 546 671 148 160 448 450 560 542 14 12 54 45 90 75 88 73 219 172 313 238 42 29 77 57 77 62 0 5 -13 34 -29 66 -69 137 -149 405 -181 602 -7 41 -14 82 -15 90 -1 8 -6 46 -10 83 -3 37 -8 77 -10 88 -2 11 -7 65 -11 122 -3 56 -8 104 -9 107 -2 3 0 12 5 19 6 10 10 8 15 -10 10 -34 167 -346 228 -454 118 -210 319 -515 340 -515 4 0 40 18 80 40 230 128 521 255 787 343 118 40 336 102 395 113 28 5 53 11 105 23 25 5 59 12 75 15 17 3 41 8 55 11 34 7 274 43 335 50 152 18 372 29 565 29 194 0 481 -11 489 -19 2 -3 -3 -6 -12 -6 -9 -1 -20 -2 -24 -3 -33 -8 -73 -16 -98 -21 -61 -10 -264 -56 -390 -90 -649 -170 -1243 -437 -1770 -794 -60 -41 -121 -82 -134 -93 l-24 -18 124 -59 c109 -52 282 -116 404 -149 92 -26 192 -51 220 -55 17 -3 64 -12 105 -21 71 -14 151 -28 230 -41 19 -3 46 -7 60 -10 14 -2 45 -7 70 -10 25 -4 56 -8 70 -10 14 -2 53 -7 88 -10 35 -4 71 -8 81 -10 10 -2 51 -6 92 -9 101 -9 141 -14 147 -21 3 -3 -15 -5 -39 -6 -24 0 -52 -2 -62 -4 -21 -4 -139 -12 -307 -22 -242 -14 -700 -7 -880 13 -41 4 -187 27 -250 39 -125 23 -274 68 -373 111 -43 19 -81 34 -86 34 -4 0 -16 -8 -27 -17 -10 -10 -37 -33 -59 -52 -166 -141 -422 -395 -592 -586 -228 -257 -536 -672 -688 -925 -21 -36 -43 -66 -47 -68 -4 -2 -8 -7 -8 -11 0 -5 -24 -48 -54 -97 -156 -261 -493 -915 -480 -935 2 -3 47 -21 101 -38 54 -18 107 -36 118 -41 58 -25 458 -138 640 -181 118 -27 126 -29 155 -35 14 -2 45 -9 70 -14 66 -15 137 -28 300 -55 37 -7 248 -33 305 -39 28 -3 84 -9 125 -13 163 -16 792 -8 913 12 12 2 58 9 102 15 248 35 423 76 665 157 58 19 134 46 170 60 86 33 344 156 348 166 2 4 8 7 13 7 14 0 205 116 303 184 180 126 287 216 466 396 282 281 511 593 775 1055 43 75 178 347 225 455 100 227 236 602 286 790 59 220 95 364 120 485 6 28 45 245 50 275 2 14 7 41 10 60 3 19 8 49 10 65 2 17 6 46 9 65 15 100 35 262 40 335 3 39 8 89 10 112 22 225 33 803 21 1043 -3 41 -7 129 -11 195 -3 66 -8 136 -10 155 -2 19 -6 76 -10 125 -3 50 -8 101 -10 115 -2 14 -6 57 -10 95 -7 72 -12 113 -20 175 -2 19 -7 55 -10 80 -6 46 -43 295 -51 340 -2 14 -9 54 -15 90 -5 36 -16 97 -24 135 -8 39 -17 84 -20 100 -12 68 -18 97 -50 248 -19 87 -47 204 -61 260 -14 56 -27 109 -29 117 -30 147 -232 810 -253 832 -4 4 -7 -23 -8 -60z"></path>
//                             </svg>
//                         </a>
//                         <button onClick={toggleMenu} className="navbar-close">
//                             <svg className="h-6 w-6 text-gray-700" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
//                                 <path fillRule="evenodd" clipRule="evenodd" d="M19.78 20.377a1.665 1.665 0 01-1.176.487H5.394a1.665 1.665 0 01-1.176-.487 1.657 1.657 0 01-.487-1.176v-8.471a1.657 1.657 0 01.487-1.176 1.665 1.665 0 011.176-.487H18.42a1.665 1.665 0 011.176.487 1.657 1.657 0 01.487 1.176v8.471c0 .459-.163.848-.487 1.176z" fill="#4a5568"></path>
//                                 <path fillRule="evenodd" clipRule="evenodd" d="M17.798 7.575a.78.78 0 00-1.106 0L12 12.894 7.308 8.455a.78.78 0 00-1.106 1.105L10.794 12l-4.592 4.444a.78.78 0 101.106 1.105L12 13.106l4.692 4.443a.777.777 0 001.106 0 .78.78 0 000-1.105L13.206 12l4.592-4.443a.78.78 0 000-1.105z" fill="#4a5568"></path>
//                             </svg>
//                         </button>
//                     </div>
//                     {isMenuOpen && (
//                         <div className="md:hidden mt-5 transition duration-300 ease-in-out translate-x-0">
//                             <ul className="flex flex-col space-y-3">
//                                 <li>
//                                     <p className="cursor-pointer">Home</p>
//                                 </li>
//                                 <li>
//                                     <p className="cursor-pointer">About Us</p>
//                                 </li>
//                                 <li>
//                                     <p className="cursor-pointer">Contact Us</p>
//                                 </li>
//                                 <li>
//                                     <p className="cursor-pointer">Disclaimer</p>
//                                 </li>
//                                 <li>
//                                     <p className="cursor-pointer">DMCA</p>
//                                 </li>
//                                 <li>
//                                     <p className="cursor-pointer">Privacy-Policy</p>
//                                 </li>
//                                 <li>
//                                     <p className="cursor-pointer">Terms & Condition</p>
//                                 </li>
//                             </ul>
//                         </div>
//                     )}
//                 </nav>
//             </div>
//         </div>
//     );
// }

// export default Header;



// import React, { useState } from 'react';
// import Logo from "../../assats/logo.webp";
// import { useNavigate } from 'react-router-dom';


// function Header() {
//     const navigate = useNavigate();
//     const [isOpen, setIsOpen] = useState(false);

//     return (
//         <nav className="flex items-center justify-between flex-wrap shadow-lg  px-5  w-full bg-transparent">
//             <div className="flex items-center flex-shrink-0 text-white mr-6 lg:mr-16">
//                 <img src={Logo} className="w-100 h-16 mr-2" alt="Logo" />
//             </div>
//             <div className="block lg:hidden">
//                 <button
//                     onClick={() => setIsOpen(!isOpen)}
//                     className="flex items-center px-3 py-2 rounded text-black-500 hover:text-black-400"  >
//                     <svg
//                         className={`fill-current h-3 w-3 ${isOpen ? "hidden" : "block"}`}
//                         viewBox="0 0 20 20"
//                         xmlns="http://www.w3.org/2000/svg" >
//                         <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
//                     </svg>
//                     <svg
//                         className={`fill-current h-3 w-3 ${isOpen ? "block" : "hidden"}`}
//                         viewBox="0 0 20 20"
//                         xmlns="http://www.w3.org/2000/svg" >
//                         <path d="M10 8.586L2.929 1.515 1.515 2.929 8.586 10l-7.071 7.071 1.414 1.414L10 11.414l7.071 7.071 1.414-1.414L11.414 10l7.071-7.071-1.414-1.414L10 8.586z" />
//                     </svg>
//                 </button>
//             </div>
//             <div
//                 className={`w-full block flex-grow lg:flex lg:items-center lg:w-auto ${isOpen ? "block" : "hidden"}`} >
//                 <div className="text-sm lg:flex-grow lg:space-x-5">
//                     <a href="/" className="block mt-4 lg:inline-block lg:mt-0 text-gray-1000 hover:text-gray-500 text-[15px] tracking-wider">
//                         Home
//                     </a>
//                     <a href="/about-us" className="block mt-4 lg:inline-block lg:mt-0 text-gray-1000 hover:text-gray-500 text-[15px] tracking-wider ">
//                         About Us
//                     </a>
//                     <a href="/projects" className="block mt-4 lg:inline-block lg:mt-0 text-gray-1000 hover:text-gray-500 text-[15px] tracking-wider ">
//                         Projects
//                     </a>
//                     <a href="/contact" className="block mt-4 lg:inline-block lg:mt-0 text-gray-1000 hover:text-gray-500 text-[15px] tracking-wider ">
//                         Contact
//                     </a>
//                     <a href="/faq" className="block mt-4 lg:inline-block lg:mt-0 text-gray-1000 hover:text-gray-500 text-[15px] tracking-wider ">
//                         FAQ
//                     </a>
//                     <a href="#" className="block mt-4 lg:inline-block lg:mt-0 text-gray-1000 hover:text-gray-500 text-[15px] tracking-wider ">
//                         Awards & Honors
//                     </a>
//                 </div>
//                 <div>
//                     <button className="rounded-full inline-flex items-center bg-[#915213] hover:bg-[#b68b60] border-0 py-2 px-4 text-white" onClick={() => navigate("/login")}>
//                         Log In
//                     </button>
//                 </div>
//             </div>
//         </nav>
//     );
// }
// export default Header;